import { StyleSheet, css } from 'aphrodite';
import React from 'react';

import ButtonLink from '@/shared/components/button-link/ButtonLink';

type Props = {
  experienceURL: string;
  onDeviceConnectionAttempt: () => void;
};

const OpenWithExpoButton = ({ experienceURL, onDeviceConnectionAttempt }: Props) => (
  <ButtonLink
    variant="primary"
    target="_blank"
    href={experienceURL}
    className={css(styles.button)}
    onClick={onDeviceConnectionAttempt}
  >
    Open with Expo Go
  </ButtonLink>
);

export default OpenWithExpoButton;

const styles = StyleSheet.create({
  button: {
    display: 'block',
  },
});
